import { atomWithReset } from "jotai/utils";

export const exportOrderModalAtom = atomWithReset({ visible: false });
